// extracted by mini-css-extract-plugin
var _1 = "ra-home-trending-arrow";
var _2 = "ra-home-trending";
export { _1 as "homeTrendingArrowCls", _2 as "homeTrendingCls" }
